<template>
    <el-container>
        <el-header>
            <el-form :inline="true" :model="fromRole" ref="fromRole" class="demo-form-inline" :rules="rules">
                <el-row :gutter="20">
                    <el-col>
                        <td-permission :roles="roles" style="float:right;">
                            <div slot="havePermission">
                                <el-form-item :label="$t('common.CURSYS')">
                                    <td-select
                                        v-model="fromRole.sSysFlg"
                                        :placeholder="$t('common.PLEASE_SELECT')"
                                        @change="queryPageBySys()"
                                        :options="this.sysAndFlgList"
                                        keys="sSysFlg"
                                        text="sName"
                                        :clearable="false"
                                    >
                                    </td-select>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <td-permission :permissions="permissionsView">
                            <div slot="havePermission">
                                <el-form-item :label="$t('common.ROLENAME')">
                                    <td-input placeholder="common.PLEASE_INPUT" v-model="fromRole.roleName"></td-input>
                                </el-form-item>
                                <el-form-item :label="$t('common.ROLE_TYPE')">
                                    <td-select v-model="fromRole.deptType" :placeholder="$t('common.PLEASE_SELECT')" :options="this.orgTypeList" keys="orgType" text="orgName"> </td-select>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <el-form-item>
                            <td-button type="primary" :permissions="permissionsView" :loading="loading" @click.native="queryPageList()">{{ $t('common.QUERY') }}</td-button>
                            <td-button type="button" :permissions="permissionsAdd" @click.native="btnAddRole">{{ $t('common.ADD') }}</td-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :permissions="permissionsView"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                :hasMutiSelect="false"
                rowKey="roleId"
                :hasLoading="loading"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
            ></td-table>
            <!-- <el-table :data="tableData"
                border
                row-key="index"
                align="left">
                <el-table-column v-for="(item, index) in columns"
                    :key="`col_${index}`"
                    :prop="item.prop"
                    :label="item.label">
                </el-table-column>
            </el-table> -->
            <!-- 加载dialog -->
            <dialog-RoleInfo
                v-if="dialogRoleVisible"
                :isAddData="isAddData"
                :dialogRoleVisible="dialogRoleVisible"
                :sysList="this.sysList"
                :sysFlg="this.fromRole.sSysFlg"
                :checkedMenu="checkedMenu"
                :checkedDept="checkedDept"
                :editItem="editItem"
                :title="title"
                ref="addOrModifyInfo"
                @roleDialogClose="roleDialogClose"
                @submit="submit"
                :orgTreeUrl="orgTreeUrl"
                :doorTreeUrl="doorTreeUrl"
            ></dialog-RoleInfo>
        </el-main>
    </el-container>
</template>

<script>
import dialogRoleInfo from './components/dialogRoleInfo.vue';
import resourceApi from './assets/api.js';
// import Sortable from 'sortablejs'
export default {
    // 初始化渲染
    components: {
        'dialog-RoleInfo': dialogRoleInfo
    },
    created() {
        if (this.$common.systemInfo.systemId) {
            this.fromRole.sSysFlg = this.$common.systemInfo.systemId;
        } else {
            this.fromRole.sSysFlg = 'PG';
        }

        let param = {};
        resourceApi.getSysList(JSON.stringify(param), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                // this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('sys/getSysList', response.data.statusMessage);
            }
            this.sysList = response.data.content;
            this.sysAndFlgList = [];
            for (let index = 0; index < this.sysList.length; index++) {
                let element = this.sysList[index];
                this.sysAndFlgList.push({ sName: element.sName + '：' + element.sSysFlg, sSysFlg: element.sSysFlg });
            }
            // this.getMenuUrl();
            let arr = this.sysList;
            for (let index in arr) {
                if (arr[index].sSysFlg === this.fromRole.sSysFlg) {
                    this.menuUrl = arr[index].sMenuUrl;
                    this.hostUrl = arr[index].sUrl;
                    this.deptUrl = arr[index].sDeptUrl;
                }
            }
        });
    },
    beforeDestroy() {
        // resourceApi = null;
        // dialogRoleInfo = null;
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        // this.rowDrop()
        this.queryPageList(); // 进行页面初始化数据的加载
    },
    // 定义数据
    data() {
        return {
            fromRole: {
                roleName: '',
                deptType: '',
                sSysFlg: ''
            },
            permissionsAdd: ['role:add'],
            permissionsEdit: ['role:edit'],
            permissionsView: ['role:view'],
            permissionsDel: ['role:del'],
            roles: ['admin'],
            sysList: [],
            sysAndFlgList: [],
            orgTypeList: [{ orgType: '', orgName: this.$t('common.ALL') }, { orgType: '0', orgName: this.$t('common.NORMAL_ROLE') }, { orgType: '1', orgName: this.$t('common.ORG_ROLE') }, { orgType: '2', orgName: this.$t('role.DOOR_ROLE') }],
            editItem: '',
            dialogRoleVisible: false,
            menuUrl: '',
            deptUrl: '',
            hostUrl: '',
            menuList: [],
            deptList: [],
            tableData: [],
            checkedMenu: [],
            checkedDept: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            orgTreeUrl: { query: '', search: '' },
            doorTreeUrl: { query: '', search: '' },
            // 对表单进行数据验证
            rules: {
                roleName: [
                    {
                        pattern: this.$regex.ROLECAPTION_RULE,
                        message: this.$t('error.ERROR_ROLE_CAPTION_ILLEGAL')
                    }
                ]
            },
            columns: [
                {
                    prop: 'roleName',
                    label: this.$t('common.ROLENAME')
                },
                {
                    prop: 'authName',
                    label: this.$t('common.ROLE_TYPE'),
                    render: (createElement, params) => {
                        let res = params.row.sParam;
                        switch (params.row.deptType) {
                            case '0':
                                res = this.$t('common.NORMAL_ROLE');
                                break;
                            case '1':
                                res = this.$t('common.ORG_ROLE');
                                break;
                            case '2':
                                res = this.$t('role.DOOR_ROLE');
                                break;
                            default:
                                break;
                        }
                        return createElement('div', res);
                    }
                },
                {
                    prop: 'roleDescription',
                    label: this.$t('common.DESCRIPTION')
                },
                {
                    prop: '',
                    label: this.$t('common.OPERATE'),
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        let result = [];
                        if (params.row.deptType !== '1') {
                            let editBtn = createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnEdit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            );
                            let delBtn = createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnDelete(params.row.roleId);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            );

                            if (params.row.roleId !== 'admin') {
                                result.push(editBtn);
                                result.push(delBtn);
                            }
                        } else {
                            result = [
                                createElement(
                                    'td-button',
                                    {
                                        props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.btnEdit(params.row);
                                            }
                                        }
                                    },
                                    this.$t('common.EDIT')
                                )
                            ];
                        }
                        return createElement('div', result);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 根据mq的id显示对应的类型名称
        formatterType(row) {
            switch (row.iType) {
                case 0:
                    return this.$t('common.RABBITMQ');
                // break
                default:
                    return this.$t('common.UNKNOW_TYPE');
            }
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryPageList();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },
        queryPageList() {
            this.currentPage = 1;
            // this.getMenuUrl();
            this.btnQuery();
        },
        queryPageBySys() {
            this.currentPage = 1;
            if (this.fromRole.sSysFlg !== 'nextPageValue' && this.fromRole.sSysFlg !== 'lastPageValue') {
                this.btnQuery();
                let arr = this.sysList;
                for (let index in arr) {
                    if (arr[index].sSysFlg === this.fromRole.sSysFlg) {
                        this.menuUrl = arr[index].sMenuUrl;
                        this.hostUrl = arr[index].sUrl;
                        this.deptUrl = arr[index].sDeptUrl;
                    }
                }
            }
        },
        getMenuUrl() {
            let arr = this.sysList;
            for (let index in arr) {
                if (arr[index].sSysFlg === this.fromRole.sSysFlg) {
                    this.menuUrl = arr[index].sMenuUrl;
                    this.hostUrl = arr[index].sUrl;
                    this.deptUrl = arr[index].sDeptUrl;
                }
            }
            let param = {
                url: this.hostUrl,
                menuUrl: this.menuUrl,
                deptUrl: this.deptUrl
            };

            if (this.menuUrl !== '') {
                resourceApi.getMenuList(JSON.stringify(param), response => {
                    if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                        this.$log.error(this.hostUrl + this.menuUrl, response.data.statusMessage);
                        return;
                    }

                    this.menuList = response.data.content;
                });
            }
            if (this.deptUrl !== '') {
                resourceApi.getOrgList(JSON.stringify(param), response => {
                    if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                        this.$log.error(this.hostUrl + this.deptUrl, response.data.statusMessage);
                        return;
                    }
                    let deptData = response.data.content;
                    this.deptList = deptData;
                });
            }
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                sysFlg: this.fromRole.sSysFlg,
                roleName: this.fromRole.roleName,
                deptType: this.fromRole.deptType,
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            resourceApi.listRoleInfos(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('role/getRoleAuthList', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        // 添加
        btnAddRole() {
            this.title = this.$t('common.ADD_ROLE'); // 标题
            this.isAddData = true;
            this.dialogRoleVisible = true;
            this.orgTreeUrl.query = this.hostUrl + this.deptUrl;
            this.orgTreeUrl.search = this.hostUrl + '/OrgManagerController/find';
            this.doorTreeUrl.query = this.hostUrl + '/device/queryDeviceOrgTree';
            this.doorTreeUrl.search = this.hostUrl + '/device/queryDeviceOrgTreeByName';
        },
        // 添加 
        btnRefresh() {
            this.title = this.$t('common.ADD'); // 标题
            this.isAddData = true;
            this.dialogRoleVisible = true;
        },
        // 编辑
        btnEdit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT_ROLE');
            this.isAddData = false;
            this.dialogRoleVisible = true;
            this.orgTreeUrl.query = this.hostUrl + this.deptUrl;
            this.orgTreeUrl.search = this.hostUrl + '/OrgManagerController/find';
            this.doorTreeUrl.query = this.hostUrl + '/device/queryDeviceOrgTree';
            this.doorTreeUrl.search = this.hostUrl + '/device/queryDeviceOrgTreeByName';
            // let param = {
            //     roleId: this.editItem.roleId,
            //     rootFlg: 'true',
            //     menuType: '3000'
            // }
            // this.checkedMenu = []

            // resourceApi.getCheckedRoleMenu(JSON.stringify(param), response => {
            //     if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
            //         this.$message.error(response.data.statusMessage)
            //         this.$log.error('role/getCheckedRoleMenu', response.data.statusMessage)
            //         return
            //     }
            //     let dataList = []
            //     let menus = response.data.content
            //     for (let i in menus) {
            //         dataList.push(menus[i].sResId)
            //     }
            //     this.checkedMenu = dataList
            // })
            // let paramDept = {
            //     roleId: this.editItem.roleId,
            //     menuType: '998'
            // }
            // this.checkedDept = []

            // resourceApi.getCheckedRoleMenu(JSON.stringify(paramDept), response => {
            //     if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
            //         this.$message.error(response.data.statusMessage)
            //         this.$log.error('role/getCheckedRoleMenu', response.data.statusMessage)
            //         return
            //     }
            //     let dataList = []
            //     let menus = response.data.content
            //     for (let i in menus) {
            //         dataList.push(menus[i].sResId)
            //     }
            //     this.checkedDept = dataList
            // })
        },
        // 删除接口
        btnDelete(roleId) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = { roleId: roleId, sysFlg: this.fromRole.sSysFlg };
                    resourceApi.deleteRoleInfo(param, response => {
                        if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('role/deleteRoleInfo', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {
                    // this.$message.info(this.$t('common.ADD_FAIL'))
                    // this.$log.error('roleInfo/btnDelete---- Fail')
                });
        },
        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        // 行拖拽
        // rowDrop () {
        //     const tbody = document.querySelector('.el-table__body-wrapper tbody')
        //     const _this = this
        //     Sortable.create(tbody, {
        //         onEnd ({ newIndex, oldIndex }) {
        //             const currRow = _this.tableData.splice(oldIndex, 1)[0]
        //             _this.tableData.splice(newIndex, 0, currRow)
        //         }
        //     })
        // },
        transData(a, idStr, pidStr, chindrenStr) {
            let r = [];
            let hash = {};
            let id = idStr;
            let pid = pidStr;
            let children = chindrenStr;
            let i = 0;
            let j = 0;
            let len = a.length;
            for (; i < len; i++) {
                hash[a[i][id]] = a[i];
            }
            for (; j < len; j++) {
                let aVal = a[j];
                let hashVP = hash[aVal[pid]];
                if (hashVP) {
                    !hashVP[children] && (hashVP[children] = []);
                    hashVP[children].push(aVal);
                } else {
                    r.push(aVal);
                }
            }
            return r;
        },
        // 关闭页面
        roleDialogClose() {
            this.dialogRoleVisible = false;
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
